import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M8 14.5v0a4.002 4.002 0 01-4-4.001V5.5a4.002 4.002 0 018.003 0v5A4.002 4.002 0 018 14.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M7.999 12.5v0a2 2 0 01-2-2v-5a2 2 0 014 0v5a2 2 0 01-2 2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M3.999 10.5h1.925M6.037 9h1.925m.075-2h1.925m.241-1.5h1.722"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M7.975 5l.024 6"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 21.75v0a6.002 6.002 0 01-6.002-6.002V8.252a6.002 6.002 0 0112.004 0v7.496A6.002 6.002 0 0112 21.75z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.998 18.75v0a3 3 0 01-3-3V8.249a3 3 0 016 0v7.501a3 3 0 01-3 3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "1.5",
    d: "M5.998 15.75h2.887m.17-2.25h2.887m.113-3h2.887m.363-2.25h2.583"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.961 7.5l.037 9"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 43.5v0c-6.63 0-12.004-5.376-12.004-12.004V16.504C11.996 9.876 17.37 4.5 24 4.5s12.004 5.376 12.004 12.004v14.992C36.004 38.124 30.63 43.5 24 43.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.995 37.5v0a6 6 0 01-6-6V16.498a6 6 0 0112 0V31.5a6 6 0 01-6 6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "3",
    d: "M11.996 31.5h5.774m.34-4.5h5.773m.227-6h5.773m.727-4.5h5.165"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.923 15l.072 18"
  }))
};
export var Track = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});